import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ChevronRightIcon = createIcon({
  displayName: 'ChevronRightIcon',
  path: (
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M10.75 8.75L14.25 12L10.75 15.25'
    />
  ),
  defaultProps: defaultProps
})
